<section class="section-white" *ngIf="pricingData">
  <div class="section-container-inside">
    <h2 class="section-heading mar-b-48">
      {{ pricingData?.header }}
    </h2>
    <div class="kenyan-rate">
      <div class="kenyan-rate-header">
        <div class="row-padd-24">
          <div
            class="form-check text-lg form-switch flex gap-8 align-items-center responsive-justify-content"
            style="padding-inline: 1rem; margin-block: 1rem"
          >
            <input
              class="form-check-input"
              type="checkbox"
              id="rateInvert"
              (change)="invertRate($event)"
            />
            <p>Inverse</p>
          </div>
        </div>
        <div class="coloumn-middle row-padd-24">
          {{ pricingData.header2 || 'Amount' }}
        </div>
        <div class="row-padd-24">{{ pricingData.header3 || 'Change' }}</div>
      </div>
      <div class="kenyan-rate-row" *ngIf="usdChange">
        <div class="row-padd-24 kenyan-rate-content-bold">
          {{ usdChange.label }}
        </div>
        <div class="row-padd-24 coloumn-middle kenyan-rate-content">
          {{ usdChange.rateAfterSpread | number: '1.4' }}
        </div>
        <div class="row-padd-24 kenyan-rate-content">
          {{ usdChange?.overnightPercentChange > 0 ? '+' : ''
          }}{{ usdChange?.overnightPercentChange | number: '1.4' }}%
          <span class="green-800" *ngIf="usdChange?.overnightPercentChange > 0">
            &uarr;</span
          >
          <span class="red-800" *ngIf="usdChange?.overnightPercentChange < 0">
            &darr;</span
          >
        </div>
      </div>
      <div class="kenyan-rate-row" *ngIf="euroChange">
        <div class="row-padd-24 kenyan-rate-content-bold">
          {{ euroChange.label }}
        </div>
        <div class="row-padd-24 coloumn-middle kenyan-rate-content">
          {{ euroChange.rateAfterSpread | number: '1.4' }}
        </div>
        <div class="row-padd-24 kenyan-rate-content">
          {{ euroChange?.overnightPercentChange > 0 ? '+' : ''
          }}{{ euroChange?.overnightPercentChange | number: '1.4' }}%
          <span
            class="green-800"
            *ngIf="euroChange?.overnightPercentChange > 0"
          >
            &uarr;</span
          >
          <span class="red-800" *ngIf="euroChange?.overnightPercentChange < 0">
            &darr;</span
          >
        </div>
      </div>
      <div class="kenyan-rate-row" *ngIf="gbpChange">
        <div class="row-padd-24 kenyan-rate-content-bold">
          {{ gbpChange.label }}
        </div>
        <div class="row-padd-24 coloumn-middle kenyan-rate-content">
          {{ gbpChange.rateAfterSpread | number: '1.4' }}
        </div>
        <div class="row-padd-24 kenyan-rate-content">
          {{ gbpChange?.overnightPercentChange > 0 ? '+' : ''
          }}{{ gbpChange?.overnightPercentChange | number: '1.4' }}%
          <span class="green-800" *ngIf="gbpChange?.overnightPercentChange > 0">
            &uarr;</span
          >
          <span class="red-800" *ngIf="gbpChange?.overnightPercentChange < 0">
            &darr;</span
          >
        </div>
      </div>
      <div class="kenyan-rate-row" *ngIf="jpyChange">
        <div class="row-padd-24 kenyan-rate-content-bold">
          {{ jpyChange.label }}
        </div>
        <div class="row-padd-24 coloumn-middle kenyan-rate-content">
          {{ jpyChange.rateAfterSpread | number: '1.4' }}
        </div>
        <div class="row-padd-24 kenyan-rate-content">
          {{ jpyChange?.overnightPercentChange > 0 ? '+' : ''
          }}{{ jpyChange?.overnightPercentChange | number: '1.4' }}%
          <span class="green-800" *ngIf="jpyChange?.overnightPercentChange > 0">
            &uarr;</span
          >
          <span class="red-800" *ngIf="jpyChange?.overnightPercentChange < 0">
            &darr;</span
          >
        </div>
      </div>
      <div class="kenyan-rate-row" *ngIf="audChange">
        <div class="row-padd-24 kenyan-rate-content-bold">
          {{ audChange.label }}
        </div>
        <div class="row-padd-24 coloumn-middle kenyan-rate-content">
          {{ audChange.rateAfterSpread | number: '1.4' }}
        </div>
        <div class="row-padd-24 kenyan-rate-content">
          {{ audChange?.overnightPercentChange > 0 ? '+' : ''
          }}{{ audChange?.overnightPercentChange | number: '1.4' }}%
          <span class="green-800" *ngIf="audChange?.overnightPercentChange > 0">
            &uarr;</span
          >
          <span class="red-800" *ngIf="audChange?.overnightPercentChange < 0">
            &darr;</span
          >
        </div>
      </div>
      <div class="kenyan-rate-row" *ngIf="cadChange">
        <div class="row-padd-24 kenyan-rate-content-bold">
          {{ cadChange.label }}
        </div>
        <div class="row-padd-24 coloumn-middle kenyan-rate-content">
          {{ cadChange.rateAfterSpread | number: '1.4' }}
        </div>
        <div class="row-padd-24 kenyan-rate-content">
          {{ cadChange?.overnightPercentChange > 0 ? '+' : ''
          }}{{ cadChange?.overnightPercentChange | number: '1.4' }}%
          <span class="green-800" *ngIf="cadChange?.overnightPercentChange > 0">
            &uarr;</span
          >
          <span class="red-800" *ngIf="cadChange?.overnightPercentChange < 0">
            &darr;</span
          >
        </div>
      </div>
      <div class="kenyan-rate-row" *ngIf="cnyChange">
        <div class="row-padd-24 kenyan-rate-content-bold">
          {{ cnyChange.label }}
        </div>
        <div class="row-padd-24 coloumn-middle kenyan-rate-content">
          {{ cnyChange.rateAfterSpread | number: '1.4' }}
        </div>
        <div class="row-padd-24 kenyan-rate-content">
          {{ cnyChange?.overnightPercentChange > 0 ? '+' : ''
          }}{{ cnyChange?.overnightPercentChange | number: '1.4' }}%
          <span class="green-800" *ngIf="cnyChange?.overnightPercentChange > 0">
            &uarr;</span
          >
          <span class="red-800" *ngIf="cnyChange?.overnightPercentChange < 0">
            &darr;</span
          >
        </div>
      </div>
    </div>
  </div>
</section>
